import { SET_LESSONS } from "../actions/lessonsActions";

const initState = [];

export const uiReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_LESSONS:
      return [...action.payload];

    default:
      return state;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/lessonsReducer.js